// RequireAuth.tsx
import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';

interface RequireAuthProps {
  children: React.ReactNode;
}

function RequireAuth({ children }: RequireAuthProps) {
  const location = useLocation();
  const { route } = useAuthenticator(context => [context.route]);

  if (route !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // ユーザーが認証されている場合、子コンポーネントをレンダリングします。
  return <>{children}</>;
}

export default RequireAuth;
